// 圖示走 inline SVG：CSP 擋外部資源，而為了幾個圖示背一整包字型並不划算。
export const Icon = ({ d, size = 20 }: { d: string; size?: number }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} aria-hidden="true">
    <path d={d} fill="none" stroke="currentColor" strokeWidth="1.8"
      strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

export const PATH = {
  menu: 'M4 7h16M4 12h16M4 17h16',
  plus: 'M12 5v14M5 12h14',
  chat: 'M21 12a8 8 0 0 1-8 8H7l-4 3v-5.5A8 8 0 1 1 21 12Z',
  arrowUp: 'M12 19V5M6 11l6-6 6 6',
  arrowUpRight: 'M8 16 16 8M9 8h7v7',
  close: 'M6 6l12 12M18 6 6 18',
  chevronLeft: 'M15 6l-6 6 6 6',
  chevronRight: 'M9 6l6 6-6 6',
  pencil: 'M4 20h4L18.5 9.5a2.1 2.1 0 0 0-4-4L4 16v4ZM13.5 6.5l4 4',
}

// 停止是實心方塊，不是線條：串流中它要一眼分得出「這顆已經不是送出了」。
export const StopIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
    <rect x="7" y="7" width="10" height="10" rx="2" fill="currentColor" />
  </svg>
)
